import {createAction, props} from '@ngrx/store'
import {Samoobsluga} from '../../shared/services/samoobsluga/types/samoobsluga';
import {InitActionType} from './init-action-type';

export const zainicjalizujToken = createAction(InitActionType.ZAINICJALIZUJ_TOKEN, props<{ token: string }>());
export const pobierzDaneZgloszeniaSuccess = createAction(InitActionType.POBIERZ_DANE_ZGLOSZENIA_SUCCESS, props<Samoobsluga>());

export const pobierzParametryAdmin = createAction(InitActionType.POBIERZ_PARAMETRY_WYCENY_SZKODY);
export const zaladujStoreZSessionStorage = createAction(InitActionType.ZALADUJ_STORE_Z_SESSION_STORAGE);

export const pobierzToggles = createAction(InitActionType.POBIERZ_TOGGLES);
export const rozpocznijSamoobsluge = createAction(InitActionType.ROZPOCZNIJ_SAMOOBSLUGE, props<{ correlationId: string, samoobsluga: Samoobsluga}>());
